import {axiosInstance, useFetch} from "./config";

export const useFetchProfile = (link) => useFetch(() => requestGetProfile(link))
export const useFetchTagCard = (cardUuid) => useFetch(() => requestTagCard(cardUuid))
export const useFetchTermOfService = () => useFetch(() => requestTermOfService())

export const requestTermOfService = async () =>
    await axiosInstance.get(`/api/tos`)
export const requestTagCard = async (cardUuid) =>
    await axiosInstance.get(`/api/card/${cardUuid}`)
export const requestGetProfile = async (link) =>
    await axiosInstance.get(`/api/profile/${link}`)

export const requestSignup = async (signupParams) =>
    await axiosInstance.post("/api/signup", signupParams)

export const requestLogin = async (oauthProvider, oauthAccessToken) =>
    await axiosInstance.post("/api/login",
        {
            oauthProvider: oauthProvider,
            oauthAccessToken: oauthAccessToken
        }
    )

export const requestCheckUserSession = async () =>
    await axiosInstance.get("/api/session/check")

export const requestLogout = async () =>
    await axiosInstance.post("/api/logout")

export const requestDeleteUser = async () =>
    await axiosInstance.delete("/api/user")

export const requestCreateProfile = async (params) =>
    await axiosInstance.post("/api/profile", params)

export const requestEditProfile = async (link, params) =>
    await axiosInstance.put(`/api/profile/${link}`, params)

export const requestUploadProfileAndBackgroundImage = async (link, params) =>
    await axiosInstance.post(`/api/profile/${link}/image/upload`, params)